var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-card-flat-rounded', _vm._b({}, 'u-card-flat-rounded', _vm.$attrs, false), [_vm.innerClass || _vm.cardInnerSize ? [_c('div', {
    staticClass: "card-inner",
    class: [_vm.innerClass, _vm.cardInnerSize]
  }, [_vm._t("default")], 2)] : [_vm._t("default")]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }